import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { DeeplinkComponent } from "./deeplink/deeplink.component";

const routes: Routes = [{ path: "deeplink", component: DeeplinkComponent }];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
